// extracted by css-extract-rspack-plugin
export default {"container":"dz4BrYj2f8W6avC9","right":"SrKywYqyWQNbfLq4","directionLabel":"vDcC8mDeYZs2OVKw"};